<div class="py-16 mb-8 px-container">
    <div class="flex justify-between items-center flex-wrap-reverse gap-y-16">
        <h1 class="text-5xl md:text-6xl pb-4 px-4 bg-no-repeat bg-bottom bg-contain inline mb-0" style="background-image: url('assets/images/scribble.svg');">Informazioni utili</h1>
        <a class="text-lg cta-link self-center" routerLink="/abbecedario">visita l'abbecedario</a>
    </div>
          
    <div class="info-columns mt-16">
        <div *ngFor="let info of infos" class="info-columns-item flex flex-col gap-8">
            <article class="lg:pe-8"  *ngFor="let item of info.items">
                <div class="left-0 absolute border-gray-300 border-l-2 border-dashed w-2 h-full"></div>
                <h1 class="lg:text-4xl text-3xl">{{item.titolo}}</h1>
                <div [innerHTML]="item.descrizione"></div>
                <a *ngIf="item.titolo.toLowerCase() == 'persone con disabilità'" class="btn btn-sm btn-primary block md:inline-block mt-4 !no-underline cursor-pointer text-center" href="../../../assets/pdf/Modulo_TC.pdf" target="_blank">Scarica modulo <i class="ms-4 bi bi-download"></i></a>
            </article>
        </div>
    </div>  
    
</div>